import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import NewButton from 'ui/atoms/NewButton/NewButton'
import { useSnapshot } from 'valtio'
import { dayAheadBidTableStore } from '../../store/dayAheadBidTableStore'

export function DayAheadBidTableSaveAction(): ReactNode {
  const { t } = useTranslation()
  const dayAheadBidTableSnap = useSnapshot(dayAheadBidTableStore)

  if (!dayAheadBidTableSnap.savePendingEdits) {
    return null
  }

  return (
    <NewButton
      variant="save"
      label={t('Save')}
      disabled={!dayAheadBidTableSnap.hasPendingEdits || dayAheadBidTableSnap.isSavePending}
      loading={dayAheadBidTableSnap.isSavePending}
      tooltip={
        dayAheadBidTableSnap.hasPendingEdits || dayAheadBidTableSnap.isSavePending
          ? undefined
          : { title: t('No changes to save'), placement: 'top' }
      }
      onClick={() => dayAheadBidTableStore.savePendingEdits?.()}
    />
  )
}
